export default __webpack_public_path__ + "static/media/vendor-offline.bc2c6f51.svg";